import { clsx } from "clsx";
import type { HTMLAttributes } from "react";

export type PillTone = "neutral" | "ok" | "warn" | "err" | "accent";

/** Status pill (FRONTEND_DESIGN.md §4.3): mono, one tint pair, always with a word. */
export function Pill({
  tone = "neutral",
  dot,
  pulse,
  className,
  children,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: PillTone; dot?: boolean; pulse?: boolean }) {
  return (
    <span
      className={clsx(
        "kss-pill",
        tone === "ok" && "bg-ok-tint text-ok",
        tone === "warn" && "bg-warn-tint text-warn",
        tone === "err" && "bg-err-tint text-err",
        tone === "accent" && "bg-accent-tint text-accent",
        tone === "neutral" &&
          "border-neutral-200 bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-200",
        className,
      )}
      {...props}
    >
      {dot && (
        <span className={clsx("h-1.5 w-1.5 rounded-full bg-current", pulse && "motion-safe:animate-pulse")} />
      )}
      {children}
    </span>
  );
}
